import { render, staticRenderFns } from "./Indicators.vue?vue&type=template&id=281f4116&scoped=true&"
import script from "./Indicators.vue?vue&type=script&lang=js&"
export * from "./Indicators.vue?vue&type=script&lang=js&"
import style0 from "./Indicators.vue?vue&type=style&index=0&id=281f4116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f4116",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBreadcrumbs,VCard,VCardText,VDialog,VTab,VTabItem,VTabs})
